import React from 'react';
import { Form, Card, Grid, Label } from 'semantic-ui-react';

import RemovePassengerLabel from '../../../RemovePassengerLabel';
import AffiliateDropdown from '../../../dropdowns/AffiliateDropdown';
import Field from '../../../Field';
import withLanguagesOptions from '../../../HOC/withLanguagesOptions';

const Passenger = ({
  passenger,
  passenger: {
    passengerFirstName,
    passengerLastName,
    passengerLanguage,
    passengerPhone,
    pnr,
    bankName,
    number,
    passengerEmail,
    employer,
    affiliate,
    id
  },
  index,
  errors,
  touched,
  onBlur,
  onPassengerChange,
  onRemovePassenger,
  removable,
  languagesOptions,
  onChange
}) => (
  <Card
    fluid
    className={`anchor-passengers-${index}`}
    color={removable ? undefined : 'green'}
  >
    <Card.Content>
      {onRemovePassenger && removable && (
        <RemovePassengerLabel
          passenger={passenger}
          handleRemovePassenger={onRemovePassenger}
        />
      )}
      <Grid>
        <Grid.Row>
          <Grid.Column width={14}>
            <Form.Group>
              <Field
                width='5'
                error={errors && errors.passengerFirstName}
                touched={touched && touched.passengerFirstName}
              >
                <Form.Input
                  name='passengerFirstName'
                  label='Name *'
                  placeholder='Name'
                  value={passengerFirstName || ''}
                  onChange={onPassengerChange.bind(this, id)}
                  onBlur={onBlur.bind(
                    this,
                    `passengers[${index}].passengerFirstName`
                  )}
                />
              </Field>
              <Field
                width='5'
                error={errors && errors.passengerLastName}
                touched={touched && touched.passengerLastName}
              >
                <Form.Input
                  name='passengerLastName'
                  label='Surname *'
                  placeholder='Surname'
                  value={passengerLastName || ''}
                  onChange={onPassengerChange.bind(this, id)}
                  onBlur={onBlur.bind(
                    this,
                    `passengers[${index}].passengerLastName`
                  )}
                />
              </Field>
              <Field
                width='5'
                error={errors && errors.passengerLanguage}
                touched={touched && touched.passengerLanguage}
              >
                <Form.Dropdown
                  selection
                  search
                  options={languagesOptions}
                  name='passengerLanguage'
                  label='Language *'
                  placeholder='Language'
                  value={passengerLanguage || ''}
                  onChange={onPassengerChange.bind(this, id)}
                  onBlur={onBlur.bind(
                    this,
                    `passengers[${index}].passengerLanguage`
                  )}
                />
              </Field>
            </Form.Group>
            <Form.Group>
              <Field width='5'>
                <Form.Input
                  placeholder='PNR'
                  value={pnr || ''}
                  onChange={onPassengerChange.bind(this, id)}
                  name='pnr'
                  label='PNR'
                  onBlur={onBlur.bind(this, `passengers[${index}].pnr`)}
                />
              </Field>
              <Field width='5'>
                <Form.Input
                  placeholder='Bank name'
                  value={bankName || ''}
                  onChange={onPassengerChange.bind(this, id)}
                  name='bankName'
                  label='Bank name'
                  onBlur={onBlur.bind(this, `passengers[${index}].bankName`)}
                />
              </Field>
              <Field
                width='5'
                error={errors && errors.number}
                touched={touched && touched.number}
              >
                <Form.Input
                  label='Ticket Number *'
                  name='number'
                  placeholder='Ticket Number *'
                  value={number || ''}
                  onChange={onPassengerChange.bind(this, id)}
                  onBlur={onBlur.bind(this, `passengers[${index}].number`)}
                />
              </Field>
            </Form.Group>
            <Form.Group>
              <Field
                width='5'
                error={errors && errors.passengerEmail}
                touched={touched && touched.passengerEmail}
              >
                <Form.Input
                  name='passengerEmail'
                  type='email'
                  label='Email *'
                  placeholder='Email'
                  value={passengerEmail || ''}
                  onChange={onPassengerChange.bind(this, id)}
                  onBlur={onBlur.bind(
                    this,
                    `passengers[${index}].passengerEmail`
                  )}
                />
              </Field>
              <Field width='5'>
                <Form.Input
                  name='employer'
                  label='Employer'
                  placeholder='Employer'
                  value={employer || ''}
                  onChange={onPassengerChange.bind(this, id)}
                />
              </Field>
              <Field
                width='5'
                error={errors && errors.affiliate}
                touched={touched && touched.affiliate}
              >
                <AffiliateDropdown
                  useId
                  name='affiliate'
                  label='Affiliate *'
                  placeholder='Affiliate'
                  value={affiliate || ''}
                  onChange={onPassengerChange.bind(this, id)}
                  onBlur={onBlur.bind(this, `passengers[${index}].affiliate`)}
                />
              </Field>
            </Form.Group>
            <Form.Group>
              <Field
                width='5'
                error={errors && errors.passengerPhone}
                touched={touched && touched.passengerPhone}
              >
                <Form.Input
                  name='passengerPhone'
                  type='phone'
                  label='Phone'
                  placeholder='Phone'
                  value={passengerPhone || ''}
                  onChange={onPassengerChange.bind(this, id)}
                  onBlur={onBlur.bind(
                    this,
                    `passengers[${index}].passengerPhone`
                  )}
                />
              </Field>
            </Form.Group>
          </Grid.Column>
          <Grid.Column width={2} textAlign='center' verticalAlign='top'>
            <Label
              style={{ cursor: 'pointer' }}
              basic
              name='passengerTicketId'
              value={id || ''}
              onClick={onChange}
              color={removable ? 'grey' : 'green'}
            >
              Contact Person
            </Label>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Card.Content>
  </Card>
);

export default withLanguagesOptions(Passenger);



// WEBPACK FOOTER //
// ./src/component/ClaimForm/Form/Passengers/Passenger.js